import React from "react";

const si = { viewBox: "0 0 16 16", fill: "none", stroke: "currentColor", strokeWidth: "1.75" };

export const ChLocationIcon = ({ size = 14 }) => (
    <svg width={size} height={size} viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.7">
        <path d="M8 1.5C5.51 1.5 3.5 3.51 3.5 6c0 3.75 4.5 8.5 4.5 8.5S12.5 9.75 12.5 6c0-2.49-2.01-4.5-4.5-4.5z" />
        <circle cx="8" cy="6" r="1.5" />
    </svg>
);

export const ChChevronIcon = () => (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" stroke="currentColor" strokeWidth="1.7">
        <path d="M2.5 4.5L6 8l3.5-3.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

export const ChSearchIcon = () => (
    <svg width="13" height="13" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.7">
        <circle cx="6.5" cy="6.5" r="4.5" />
        <path d="M10 10l3.5 3.5" strokeLinecap="round" />
    </svg>
);

export const ChCalendarIcon = () => (
    <svg width="11" height="11" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.8">
        <rect x="2" y="3" width="12" height="11" rx="1.5" />
        <path d="M5 1v3M11 1v3M2 7h12" strokeLinecap="round" />
    </svg>
);

export const ChPlusCircleIcon = () => (
    <svg {...si}><circle cx="8" cy="8" r="6.5" /><path d="M8 5v6M5 8h6" strokeLinecap="round" /></svg>
);

export const ChCheckIcon = () => (
    <svg {...si}><path d="M2.5 8.5l3.5 3.5 7-7" strokeLinecap="round" strokeLinejoin="round" /></svg>
);

export const ChAlertIcon = () => (
    <svg {...si}><circle cx="8" cy="8" r="6.5" /><path d="M8 5v3.5" strokeLinecap="round" /><circle cx="8" cy="11" r=".7" fill="currentColor" stroke="none" /></svg>
);

export const ChClockIcon = () => (
    <svg {...si}><circle cx="8" cy="8" r="6.5" /><path d="M8 5v3.5l2 2" strokeLinecap="round" strokeLinejoin="round" /></svg>
);

export const ChTrashIcon = () => (
    <svg {...si}><path d="M3 4h10M6 4V2.5h4V4M5 4l.5 9h5L11 4" strokeLinecap="round" strokeLinejoin="round" /></svg>
);

export const ChChartIcon = () => (
    <svg {...si}><rect x="2" y="2" width="12" height="12" rx="2" /><path d="M5 10V7M8 10V5M11 10V8" strokeLinecap="round" /></svg>
);

export const ChRouteIcon = () => (
    <svg {...si}><path d="M2 12c2-4 4-6 6-6s4 2 6-4" strokeLinecap="round" /></svg>
);

export const ChTimerIcon = () => (
    <svg {...si}><circle cx="8" cy="9" r="5.5" /><path d="M8 6v3.5l2 1.5" strokeLinecap="round" strokeLinejoin="round" /><path d="M6 2h4" strokeLinecap="round" /></svg>
);

export const DownloadIcon = ({ size = 14 }) => (
    <svg width={size} height={size} viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
        <path d="M8 2v8M5 7l3 3 3-3" />
        <path d="M2 12h12" />
    </svg>
);

export const ChDateRangeIcon = ({ size = 14 }) => (
    <svg width={size} height={size} viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
        <rect x="1.5" y="2.5" width="13" height="12" rx="2" />
        <path d="M1.5 6.5h13" />
        <path d="M5 1v3M11 1v3" />
        <path d="M4.5 9.5h2M9.5 9.5h2M4.5 12h2M9.5 12h2" />
    </svg>
);

export const ChSortIcon = ({ dir }) => (
    <span style={{ display: "inline-flex", flexDirection: "column", gap: 1, flexShrink: 0 }}>
        <svg width="7" height="5" viewBox="0 0 7 5" style={{ color: dir === "asc" ? "var(--ch-text, #111827)" : "var(--ch-border-md, #D0D5DD)", transition: "color .28s" }}>
            <path d="M3.5 0L7 5H0z" fill="currentColor" />
        </svg>
        <svg width="7" height="5" viewBox="0 0 7 5" style={{ color: dir === "desc" ? "var(--ch-text, #111827)" : "var(--ch-border-md, #D0D5DD)", transition: "color .28s" }}>
            <path d="M3.5 5L0 0h7z" fill="currentColor" />
        </svg>
    </span>
);
